import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from "react-router-dom";
import { LeftOutlined } from '@ant-design/icons';

import {
  Layout,
  Input,
  Row,
  Typography,
  Card,
  Select,
  Collapse,
  Form,
  DatePicker,
  Col,
  InputNumber,
  Divider,
  Button,
  Modal,
  List,
  Spin
} from "antd";
import { BOM } from "../../../../../../services/definedMethod";
import cnt from "../../../../../../services/definedConstant";
import MainLayout from '../../../../../../components/layouts/MainLayout';
import TopContent from '../../../../../../components/layouts/TopContent';
import { apiConfig, labelConfig, staticConfig } from "../../../../group.config";
import CustomButton from '../../../../../../components/custom/CustomButton';
import TextArea from 'antd/es/input/TextArea';


const { Text } = Typography

const Reschedule = (props) => {
  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [changeRepaymentDate, setChangeRepaymentDate] = useState(false);
  const [introduceGracePeriod, setIntroduceGracePeriod] = useState(false);
  const [extendRepaymentPeriod, setExtendRepaymentPeriod] = useState(false);
  const [adjustInterestRates, setAdjustInterestRates] = useState(false);
  const [changeEMI, setchangeEMI] = useState(false);
  const [changeFixedPrincipal, setchangeFixedPrincipal] = useState(false);
  const [rescheduleReasons, setRescheduleReasons] = useState([]);

  useEffect(() => {
    getTemplate();
  }, []);

  function getTemplate() {
    const url = `${apiConfig.RescheduleLoans}/template`

    let body = {
      session
    };

    setIsLoading(true)
    BOM.FetchReqAction(body, url, (err, res) => {

      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        setIsLoading(false)
        const objList = res;

        const tempRescheduleReasons = []

        objList?.rescheduleReasons?.forEach((element) =>
          tempRescheduleReasons.push({
            label: element?.name,
            value: element?.id
          })
        )

        setRescheduleReasons(tempRescheduleReasons)
      }
    });
  }

  function onCancel() {
    navigate("/detail-child-glim", { state: state });
  }

  function handleChangeRepaymentDateChange(element) {
    switch (element) {
      case true:
        setChangeRepaymentDate(true)
        break;
      case false:
        setChangeRepaymentDate(false)

      default:
        break;
    }
  }

  function handleIntroduceGracePeriodChange(element) {
    switch (element) {
      case true:
        setIntroduceGracePeriod(true)
        break;
      case false:
        setIntroduceGracePeriod(false)

      default:
        break;
    }
  }

  function handleExtendRepaymentPeriodChange(element) {
    switch (element) {
      case true:
        setExtendRepaymentPeriod(true)
        break;
      case false:
        setExtendRepaymentPeriod(false)

      default:
        break;
    }
  }

  function handleAdjustInterestRatesChange(element) {
    switch (element) {
      case true:
        setAdjustInterestRates(true)
        break;
      case false:
        setAdjustInterestRates(false)

      default:
        break;
    }
  }

  function handlechangeEMIChange(element) {
    switch (element) {
      case true:
        setchangeEMI(true)
        break;
      case false:
        setchangeEMI(false)

      default:
        break;
    }
  }

  function handleChangeFixedPrincipalChange(element) {
    switch (element) {
      case true:
        setchangeFixedPrincipal(true)
        break;
      case false:
        setchangeFixedPrincipal(false)

      default:
        break;
    }
  }

  const onSubmit = (formValues) => {

    formValues.rescheduleFromDate = formValues.rescheduleFromDate ? BOM.DateTime(formValues.rescheduleFromDate, "only-date") : formValues.rescheduleFromDate;
    formValues.adjustedDueDate = formValues.adjustedDueDate ? BOM.DateTime(formValues.adjustedDueDate, "only-date") : formValues.adjustedDueDate;
    formValues.endDate = formValues.endDate ? BOM.DateTime(formValues.endDate, "only-date") : formValues.endDate;
    formValues.submittedOnDate = formValues.submittedOnDate ? BOM.DateTime(formValues.submittedOnDate, "only-date") : formValues.submittedOnDate;

    formValues.loanId = state.loanId

    delete formValues.newFixedPrincipalPercentagePerInstallment

    const params = {
      command: "reschedule"
    }
    const url = `${apiConfig.RescheduleLoans}`

    const body = {
      ...formValues,
      locale: "en",
      method: "POST",
      dateFormat: "dd MMMM yyyy",
      locale: "en",
      session,
      params
    };

    // return
    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
        setIsLoading(false);
      } else {
        // BOM.AlertMsg(cnt.SUCCESS, labelConfig.rescheduleMsg);
        navigate("/glim-loan-reschedule-preview", { state: { ...state, resourceId: res.resourceId } });
        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  return (
    <MainLayout isEnableRightSidebar={true} >
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={labelConfig.reschedule}
        pageItems={staticConfig.rescheduleBreadcrumbItems}
      />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
          title={
            <Row
              style={{
                alignContent: "center",
                width: "8%",
              }}
            >
              <Button
                icon={<LeftOutlined />}
                type="text"
                style={{
                  marginTop: "auto",
                  marginBottom: "auto",
                }}
                onClick={onCancel}
              >
                <Text
                  style={{ marginTop: "auto", marginBottom: "auto", fontSize: 15 }}
                >
                  Back
                </Text>
              </Button>
            </Row>
          }
        >
          <Form
            form={form}
            layout="vertical"
            onFinish={onSubmit}
          >

            <Row >
              <Divider orientation="left">{`Account No: ${state.accountNo}`}</Divider>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.rescheduleFromInstallment}
                  name="rescheduleFromDate"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(
                        labelConfig.rescheduleFromInstallment
                      ),
                    },
                  ]}
                >
                  <DatePicker
                    placeholder={BOM.handlePlaceholderMsg(
                      `${labelConfig.rescheduleFromInstallment}`,
                      "select"
                    )}
                    style={{ width: "100%", height: 35 }}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.reasonForRescheduling}
                  name={"rescheduleReasonId"}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(
                        labelConfig.reasonForRescheduling
                      ),
                    },
                  ]}
                >
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      `${labelConfig.reasonForRescheduling}`,
                      "select"
                    )}
                    options={rescheduleReasons}
                    showSearch
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.submittedDate}
                  name="submittedOnDate"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(
                        labelConfig.submittedDate
                      ),
                    },
                  ]}
                >
                  <DatePicker
                    placeholder={BOM.handlePlaceholderMsg(
                      `${labelConfig.submittedDate}`,
                      "select"
                    )}
                    style={{ width: "100%", height: 35 }}
                  />
                </Form.Item>
              </Col>

              <Divider orientation="left" orientationMargin="0"></Divider>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.comment}
                  name={"comment"}
                >
                  <TextArea style={{ width: "100%", height: "10vh" }} placeholder='Please enter a comment' />

                </Form.Item>
              </Col>
            </Row>

            <Divider orientation="left" orientationMargin="0"></Divider>

            <Row >
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.changeRepaymentDate}
                  name="changeRepaymentDate"
                >
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(
                        input?.toLowerCase()
                      )
                    }
                    placeholder={BOM.handlePlaceholderMsg(
                      `${labelConfig.option}`,
                      "select"
                    )}
                    options={staticConfig.yesOrNoData}
                    showSearch
                    onChange={handleChangeRepaymentDateChange}
                  />{" "}
                </Form.Item>
              </Col>

              {changeRepaymentDate === true &&
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={labelConfig.installmentRescheduledTo}
                    name="adjustedDueDate"
                  >
                    <DatePicker
                      placeholder={BOM.handlePlaceholderMsg(
                        `${labelConfig.installmentRescheduledTo}`,
                        "select"
                      )}
                      style={{ width: "100%", height: 35 }}
                    />
                  </Form.Item>
                </Col>

              }
            </Row>

            <Row>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.introduceGracePeriod}
                  name="introduceGracePeriods"
                >
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(
                        input?.toLowerCase()
                      )
                    }
                    placeholder={BOM.handlePlaceholderMsg(
                      `${labelConfig.option}`,
                      "select"
                    )}
                    options={staticConfig.yesOrNoData}
                    showSearch
                    onChange={handleIntroduceGracePeriodChange}
                  />{" "}
                </Form.Item>
              </Col>
              {introduceGracePeriod === true &&
                <>
                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      label={labelConfig.principalGracePeriods}
                      name="graceOnPrincipal"
                    >
                      <Input
                        placeholder={BOM.handlePlaceholderMsg(
                          `${labelConfig.amount}`,
                          "select"
                        )}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      label={labelConfig.interestGracePeriods}
                      name="graceOnInterest"
                    >
                      <Input
                        placeholder={BOM.handlePlaceholderMsg(
                          `${labelConfig.amount}`,
                          "select"
                        )}
                      />
                    </Form.Item>
                  </Col>
                </>
              }
            </Row>

            <Row >
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.extendRepaymentPeriod}
                  name="extendRepaymentPeriod"
                >
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(
                        input?.toLowerCase()
                      )
                    }
                    placeholder={BOM.handlePlaceholderMsg(
                      `${labelConfig.option}`,
                      "select"
                    )}
                    options={staticConfig.yesOrNoData}
                    showSearch
                    onChange={handleExtendRepaymentPeriodChange}
                  />{" "}
                </Form.Item>
              </Col>

              {extendRepaymentPeriod === true &&
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={labelConfig.noOfNewRepayments}
                    name="extraTerms"
                  >
                    <Input
                      placeholder={BOM.handlePlaceholderMsg(
                        `${labelConfig.noOfNewRepayments}`,
                        "select"
                      )}
                    />
                  </Form.Item>
                </Col>
              }
            </Row>

            <Row>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.adjustInterestRates}
                  name="adjustinterestrates"
                >
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(
                        input?.toLowerCase()
                      )
                    }
                    placeholder={BOM.handlePlaceholderMsg(
                      `${labelConfig.adjustInterestRates}`,
                      "select"
                    )}
                    options={staticConfig.yesOrNoData}
                    showSearch
                    onChange={handleAdjustInterestRatesChange}
                  />{" "}
                </Form.Item>
              </Col>
              {adjustInterestRates === true &&
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={labelConfig.newInterestRates}
                    name="newInterestRate"
                  >
                    <Input
                      placeholder={BOM.handlePlaceholderMsg(
                        `${labelConfig.newInterestRates}`,
                        "select"
                      )}
                    />
                  </Form.Item>
                </Col>

              }
            </Row>

            <Row>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.changeEMI}
                  name="changeEMI"
                >
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(
                        input?.toLowerCase()
                      )
                    }
                    placeholder={BOM.handlePlaceholderMsg(
                      `${labelConfig.changeEMI}`,
                      "select"
                    )}
                    options={staticConfig.yesOrNoData}
                    showSearch
                    onChange={handlechangeEMIChange}
                  />{" "}
                </Form.Item>
              </Col>


              {changeEMI === true &&
                <>
                  <Col span={8} style={{ padding: "0px 8px" }}>

                    <Form.Item
                      label={labelConfig.EMIChange}
                      name="endDate"
                    >
                      <DatePicker
                        placeholder={BOM.handlePlaceholderMsg(
                          `${labelConfig.closedOn}`,
                          "select"
                        )}
                        style={{ width: "100%", height: 35 }}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      label={labelConfig.newEMI}
                      name="emi"
                    >
                      <Input
                        placeholder={BOM.handlePlaceholderMsg(
                          `${labelConfig.newEMI}`,
                          "select"
                        )}
                      />
                    </Form.Item>
                  </Col>
                </>
              }
            </Row>

            <Row>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.changeFixedPrincipal}
                  name="changeFixedPrincipal"
                >
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(
                        input?.toLowerCase()
                      )
                    }
                    placeholder={BOM.handlePlaceholderMsg(
                      `${labelConfig.changeFixedPrincipal}`,
                      "select"
                    )}
                    options={staticConfig.yesOrNoData}
                    showSearch
                    onChange={handleChangeFixedPrincipalChange}
                  />{" "}
                </Form.Item>
              </Col>

              {changeFixedPrincipal === true &&
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={labelConfig.newFixedPrincipal}
                    name="newFixedPrincipalPercentagePerInstallment"
                  >
                    <Input
                      placeholder={BOM.handlePlaceholderMsg(
                        `${labelConfig.newFixedPrincipal}`,
                        "select"
                      )}
                    />
                  </Form.Item>
                </Col>
              }
            </Row>

            <Row>
              <Divider />
              {BOM.HasPermission("APPROVE_RESCHEDULELOAN") &&
                <CustomButton
                  content="Submit"
                  style={{
                    width: "10%",
                    marginLeft: "auto",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  }}
                  htmlType="submit"
                  backgroundColor="#92428B"
                  colorText="white"
                  hoverBackground="#AD4EA7"
                />}

              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>
        </Card>
      </Spin>

    </MainLayout>

  )
}

export default Reschedule
